import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
import { getApi } from "../../../../../api/api_instance";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import SectionList from "./components/SectionList";
import SubsectionList from "./components/SubSectionList";
import { Skeleton } from "antd";
import { QuestionForm } from "./components/QuestionsForm";
import { useLocation } from "react-router-dom";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import QuestionList from "./components/QuestionList";
import { useParams } from "react-router-dom";

const scrollableContainer = {
  maxHeight: "1000px",
  overflowY: "auto",
  padding: "10px",
  borderRadius: "8px",
};

const ViewForm = ({ sectionurl, subsectionurl, questionurl }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [subsections, setSubsections] = useState([]);
  const [selectedSubsection, setSelectedSubsection] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const pageSize = 20;
  const location = useLocation();
  const { formTitle } = location.state || {};
  const navigate = useNavigate();
  const { formId } = useParams();
  useEffect(() => {
    fetchSections();
  }, []);

  const fetchSections = async () => {
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: sectionurl(currentPage, pageSize, sortOrder),
      });

      if (response.success) {
        setSections(response.data);
        if (response.data.length > 0) {
          const firstSection = response.data[0];
          setSelectedSection(firstSection._id);
          console.log(firstSection);
          fetchSubsections(firstSection._id);
        }
      } else {
        console.error("Failed to fetch sections");
      }
    } catch (error) {
      console.error("Error fetching sections", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubsections = async (sectionId) => {
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: subsectionurl(sectionId),
      });
      if (response.success) {
        setSubsections(response.data);
        setSelectedSection(sectionId);

        if (response.data.length > 0) {
          const firstSubsection = response.data[0];
          setSelectedSubsection(firstSubsection._id);
          fetchQuestions(firstSubsection._id);
        }
      } else {
        console.error("Failed to fetch subsections");
      }
    } catch (error) {
      console.error("Error fetching subsections", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuestions = useCallback(
    async (subsectionId = selectedSubsection) => {
      if (!subsectionId) return;

      setLoading(true);
      try {
        const response = await getApi({
          apiUrl: questionurl(subsectionId, searchTerm),
        });

        if (response.success) {
          console.log("Questions (raw response):", response.data);
          setQuestions(response.data);
        } else {
          setQuestions([]);
        }
      } catch (error) {
        console.error("Error fetching questions", error);
        message.error("Failed to fetch questions");
      } finally {
        setLoading(false);
      }
    },
    [searchTerm],
  );

  // useEffect(() => {
  //   fetchQuestions();
  // }, [fetchQuestions]);

  return (
    <div className="h-full px-5 pb-5 bg-white ">
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <p>Dynamic Form</p>
        <span>/</span>
        <TextStyles color="gradient">{formTitle}</TextStyles>
      </div>
      <div className="flex justify-between pb-2">
        <div className="flex items-center">
          <Back className="cursor-pointer" onClick={() => navigate(-1)} />
          <h3 className="text-[#0087A3] text-xl">{formTitle}</h3>
        </div>
      </div>

      <div className="w-full border border-[#3BA2B959] rounded-[10px] pt-5 shadow-[0_0_16px_0_#3BA2B91F] mb-6">
        <div className="grid grid-cols-5 gap-2">
          {sections.map((section) => (
            <div
              key={section._id}
              className={`pl-20 font-normal py-2 bg-transparent cursor-pointer ${
                selectedSection === section._id
                  ? "text-[#0087A3]"
                  : "text-black"
              }`}
              onClick={() => fetchSubsections(section._id)}
            >
              {section.name}
            </div>
          ))}
        </div>

        <hr className="border-t-[1px] border-[#3BA2B959] shadow-[0_0_16px_0_#3BA2B91F]" />

        {selectedSection && (
          <div className="flex flex-wrap gap-5 pt-5 pb-5 pl-16 text-[11px] font-normal border border-[#3BA2B91C] shadow-[0_0_25.2px_0_#3BA2B91F]">
            {subsections.length > 0 ? (
              subsections.map((sub) => (
                <div
                  key={sub._id}
                  className={`p-3 rounded-[2px] cursor-pointer border border-[#3BA2B929] shadow-[0_0_16px_0_#3BA2B91F] ${
                    selectedSubsection === sub._id ? "bg-teal-50" : "bg-white"
                  }`}
                  onClick={() => {
                    setSelectedSubsection(sub._id);
                    fetchQuestions(sub._id);
                  }}
                >
                  {sub.name}
                </div>
              ))
            ) : (
              <p className="text-gray-500">No subsections found.</p>
            )}
          </div>
        )}
      </div>

      <div className="w-full bg-white border border-[#3BA2B959] rounded-[10px] pt-5 shadow-[0_0_16px_0_#3BA2B91F] mb-6">
        <div className="">
          <div className="flex items-center gap-5 ml-10 mb-6">
            <div className="flex items-center justify-center h-[42px] px-6 border border-[#0087A3] bg-[#B6D4D933] rounded-md text-[#0087A3] text-base font-light">
              TOTAL QUESTIONS: {questions.length}
            </div>

            <div className="flex-shrink-0">
              <SearchBar
                width="300px"
                onSearch={(value) => setSearchTerm(value)}
              />
            </div>
          </div>

          <div style={scrollableContainer}>
            {loading ? (
              <div className="flex flex-col gap-4 p-4">
                <Skeleton.Button block active />
                <Skeleton.Button block active />
                <Skeleton.Button block active />
                <Skeleton.Button block active />
              </div>
            ) : (
              selectedSubsection && (
                <div className="mx-20 shadow-[0_0_16px_0_#3BA2B91F]">
                  {questions.length > 0 ? (
                    <QuestionForm
                      formId={formId}
                      sectionId={selectedSection}
                      subSectionId={selectedSubsection}
                      questions={questions}
                    />
                  ) : (
                    <p className="text-gray-500 text-center">
                      No questions available.
                    </p>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewForm;
